// extracted by mini-css-extract-plugin
module.exports = {"costsBox":"index-module--costsBox--1nK5i"};